import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import storeconfig, { history, loadState } from './store/storeconfig';
import * as serviceWorker from "./serviceWorker";

import './styles/app-general.scss'

const persistedState = loadState();

const store = storeconfig(persistedState);

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
